var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUpMyFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10355 5.10355C8.90829 5.29882 8.59171 5.29882 8.39645 5.10355L5.11785 1.82496C5.05277 1.75987 4.94724 1.75987 4.88215 1.82496L1.60356 5.10355C1.40829 5.29881 1.09171 5.29881 0.896449 5.10355C0.701186 4.90829 0.701186 4.59171 0.896449 4.39645L4.17504 1.11785C4.63065 0.662241 5.36935 0.66224 5.82496 1.11785L9.10355 4.39645C9.29882 4.59171 9.29882 4.90829 9.10355 5.10355Z",
    fill: "#888F9D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpMyFeedback);
export default __webpack_public_path__ + "static/media/arrowUpMyFeedback.acb5548a0703a13f1e4df155f42b90f0.svg";
export { ForwardRef as ReactComponent };